import flatten from 'lodash/flatten';
import * as baseUrlJoin from 'url-join';

export const urlJoin = (...uris: (string | string[])[]) => {
  return baseUrlJoin(...flatten(uris).filter((uri) => !!uri));
};

export default urlJoin;
